__turbopack_context__.v({
  "actions": "index-module-sass-module__EEERGq__actions",
  "buttonPrice": "index-module-sass-module__EEERGq__buttonPrice",
  "divider": "index-module-sass-module__EEERGq__divider",
});
